import React from 'react';
import cx from 'classnames';
import { Checkbox } from 'Components';

/**
 * Checkbox toggle for including inactive drivers
 */
const InactiveDriversToggle = ({
    value,
    onChange,
    entityOptionLabelClass,
    toggleId,
    messages
}) => {
    return (
        <div className={cx("entity-tag", entityOptionLabelClass)}>
            <Checkbox
                value={value}
                onChange={onChange}
                size="small"
                id={toggleId}
                optionLabels={[
                    messages['entityUnitDriverSelector_yesOption'],
                    messages['entityUnitDriverSelector_notOption']
                ]}
                classNameLabel={'label-exclude-data'}
                className="inactive-drivers-toggle__checkbox"
            />
            <span className="inactive-drivers-toggle__label">{messages['entityUnitDriverSelector_includeInactiveDrivers']}</span>
        </div>
    );
};

export default InactiveDriversToggle;

